///Moves overflowing tabs to a dropdown-button. If the user clicks on a tab in the dropdown, the last visible tab is hidden and the clicked tab is made visible
(DropdownTabHelper = function () {
    const DOM_SELECTORS = (function () {
        let tabHeaders = '#tabHeaders';
        let allTabs = tabHeaders + ' .tab-list';

        return {
            tabHeaders : tabHeaders,
            allTabs : allTabs,
            shownTabs : allTabs + ' li[style!="display: none;"]',
            hiddenTabs : allTabs + ' li[style*="display: none;"]',
            dropdownButtonContainer : '#tab-dropdown',
            dropdownButton : '#tab-drop',
            hiddenTabsContainer: '#dropdown-menu',
            tabContainerButtonsContainer: allTabs + ' .tab-container-buttons-container',
        }        
    })();

    init();

    function init() {
        attachHandlers();

        function attachHandlers() {
            //window.onresize = function (event) {
            //    setTimeout(methods.determineTabVisibility, 200);
            //};


            $(document).on('click', DOM_SELECTORS.dropdownButtonContainer, function (a, b, c) {
                $hiddenTab = $(this).find('.ui-state-active');
                methods.showTab($hiddenTab);
            });

        }
    };

    var methods = {
        showTab: function ($hiddenTab) {        
            var $tabDropdownMenu = $(DOM_SELECTORS.hiddenTabsContainer);
            var tabId = $hiddenTab.attr('id');
            var $tab = methods.getTabById(tabId);
            if ($tab.is(':hidden')) {
                methods.hideTab($(DOM_SELECTORS.shownTabs).last());
                jsUtils.tab.setTabActive(tabId);
                $tab.show();
            }

            if ($tabDropdownMenu.find('#' + tabId).length > 0) {
                $tabDropdownMenu.find('#' + tabId).remove();
            }
        },
        hideTab: function ($tab) {
            var $tabDropdownMenu = $(DOM_SELECTORS.hiddenTabsContainer);
            var tabId = $tab.attr('id');

            if (methods.getTabById(tabId).is(':visible')) {
                new Selektion().disableTab(tabId); //workaround because we dont have dependency handling
                methods.getTabById(tabId).hide();
            }

            if ($tabDropdownMenu.find('#' + $tab.attr('id')).length == 0) {
                var $clone = $tab.clone(true);
                $clone.addClass('dropdown-item');
                $clone.show();
                $tabDropdownMenu.append($clone);
            }
        }, 
        determineTabVisibility: function () {
            var tabsWidth = 0;
            var firstHidden;

            //Add Up the Tabs' widths
            $.each($(DOM_SELECTORS.shownTabs), function (idx, obj) {
                tabsWidth += $(obj).outerWidth(); //padding
            });

            //Add Up the Tab buttons' widths
            var buttonWidths = 0
            $.each($(DOM_SELECTORS.tabContainerButtonsContainer).find('button'), function (idx, obj) {
                buttonWidths += $(obj).outerWidth(); //padding
            });

            //Get Tab Area
            var dropdownButtonWidth = $(DOM_SELECTORS.dropdownButton).outerWidth();
            var tabsContainerWidth = $(DOM_SELECTORS.tabHeaders).outerWidth() - dropdownButtonWidth - buttonWidths; // - $(DOM_SELECTORS.tabHeaders)[0].scrollWidth 

            tabsWidth += dropdownButtonWidth;

            //See if we can show any
            firstHidden = $(DOM_SELECTORS.hiddenTabs).first();
            while (firstHidden.length > 0 && (tabsWidth + firstHidden.outerWidth()) < tabsContainerWidth) {
                tabsWidth += $(firstHidden).outerWidth();
                $(firstHidden).show();
                firstHidden = $(DOM_SELECTORS.hiddenTabs).first();
            }

            //Find out which ones to hide
            while (tabsWidth > tabsContainerWidth) {
                var hider = $(DOM_SELECTORS.shownTabs + ':not(.ui-state-active)').last();
                tabsWidth -= $(hider).outerWidth();
                $(hider).hide();
            }

            //Add hidden tabs to dropdown 
            var $tabDropdownMenu = $(DOM_SELECTORS.hiddenTabsContainer);
            $.each($(DOM_SELECTORS.hiddenTabs), function (i, el) {
                methods.hideTab($(el));
            })

            //If a tab is visible, remove it from the dropdown
            $.each($(DOM_SELECTORS.shownTabs), function (i, el) {
                methods.showTab($(el), true);
            })

            //Affect drop-down button
            if ($tabDropdownMenu.find('li').length === 0) {
                $(DOM_SELECTORS.dropdownButton).hide();
            } else {
                $(DOM_SELECTORS.dropdownButton).show();
            }
  
        }, 
        getTabById: function (tabId) {
            return $(DOM_SELECTORS.allTabs + ' #' + tabId);
        },
    }
})();